import React, { useState } from 'react';
import styles from './Envelope.module.css';
import selloImage from '../../assets/sello.png';
import texturaImage from '../../assets/textur.jpg';

interface EnvelopeProps {
  onOpen: () => void;
}

const Envelope: React.FC<EnvelopeProps> = ({ onOpen }) => {
  const [isOpening, setIsOpening] = useState(false);

  const handleClick = () => {
    setIsOpening(true);
    setTimeout(() => {
      onOpen();
    }, 1800);
  };

  return (
    <div 
      className={`${styles.envelopeContainer} ${isOpening ? styles.opening : ''}`}
      style={{ backgroundImage: `url(${texturaImage})` }}
    >
      <div className={styles.envelope} onClick={handleClick}>
        {/* Solapa Izquierda con curva */}
        <div className={`${styles.flap} ${styles.flapLeft}`}>
          <img src={texturaImage} alt="" className={styles.flapImage} />
        </div>
        
        {/* Solapa Derecha con curva */}
        <div className={`${styles.flap} ${styles.flapRight}`}>
          <img src={texturaImage} alt="" className={styles.flapImage} />
        </div>
        
        {/* Sello en el centro */}
        <div className={styles.seal}>
          <img src={selloImage} alt="Montserrat" />
        </div>
      </div>
      
      {!isOpening && (
        <p className={styles.instruction}>toca para abrir</p>
      )}
    </div>
  );
};

export default Envelope;
